<template>
  <div class="d2-footer">
    <p class="d2-footer-copyright">
      © CopyRight 2020-2020,<a
        target="black"
        class="d2-footer-copyright-link"
        href="http://www.beian.miit.gov.cn/"
        >京ICP备2020032285号-1</a
      >
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  created() {},
  methods: {},
}
</script>
<style scoped>
.d2-footer {
  height: 60px;
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
}
p.d2-footer-copyright {
  display: inline;
  font-size: 12px;
  text-align: center;
}
a.d2-footer-copyright-link {
  color: #333;
  font-size: 12px;
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/views/footer/footer.vue